
export default ({ onNav, className = '' }) => {
  return (
    <Link className={className} to={'/'} onClick={onNav}>
      
      Current Dodone
    </Link>
  )
}
